import { createAsyncThunk } from '@reduxjs/toolkit';

import { QuestionnaireService } from 'api';

export const getAML = createAsyncThunk('questionnaire/getAML', async () => {
	return await QuestionnaireService.getAML();
});
